export function formPost(url: string, params: any): void {
  const tmpForm = document.createElement('form')
  tmpForm.action = url
  tmpForm.target = '_self'
  tmpForm.method = 'post'
  tmpForm.style.display = 'none'
  for (const item in params) {
    const opt = document.createElement('textarea')
    opt.name = item
    opt.value = params[item]
    tmpForm.appendChild(opt)
  }
  document.body.appendChild(tmpForm)
  tmpForm.submit()
}
